<template>
    <button class="btn">
		<slot />
	</button>
</template>

<script>
export default {
    name: "Btn"
};
</script>

<style scoped>
.btn {
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
	border-radius: 5px;
	border: none;
	color: #fff;
	padding: 1rem 1.5rem 0.9rem;

	background-size: 200% auto;
	background-image: linear-gradient(to right, #9c6ade 0%, #6c37b7 50%, #9c6ade 100%);
	box-shadow: 0 1px 2px 0 rgba(33, 43, 54, 0.45);
	transition: background-position 300ms ease-in-out;
}
.btn:hover,
.btn:active {
	background-position: right center;
}
</style>